module.exports = __webpack_public_path__ + "media/images/arrow_savor-3ffd01d29d7e9dbb2ee647e73c14f579.png";